import {
    COMPANY_DELETED,
    COMPANY_DETAILS,
    COMPANY_CREATED,
    COMPANY_LOADING,
    COMPANY_EDITED,
    COMPANY_FAILED,
    COMPANY_SEARCH,
    COMPANY_LOADED,
    APIKEY_LOADING,
    APIKEY_LOADED,
    APIKEY_FAILED,
    APIKEY_GENERATED,
    LOGOUT,
    SYSTEMLOGS_LOADING,
    SYSTEMLOGS_LOADED,
    SYSTEMLOGS_FAILED,
    PROXUSER_LOADING,
    PROXUSER_LOADED,
    PROXUSER_FAILED,
    PROXUSER_EDITED,
    PROXUSER_DELETED,
    PROXUSER_CREATED,
    PROXLOGS_LOADING,
    PROXLOGS_LOADED,
    PROXLOGS_FAILED,
    CP_LOADING,
    CP_LOADED,
    CP_SEARCH,
    CP_EDITED,
    CP_FAILED,
    CP_PROXUSER_LOADED,
    CP_PROXUSER_DELETED,
    CP_PROXUSER_CREATED,
    CP_PROXUSER_EDITED,
    CP_FUND_HISTORY,
    CP_FUND_INITATE,
    CP_FUND_COMPLETED,
} from "../types";

import {
    created,
    createPaginated,
    editPaginated,
    editedUpdate,
    deleteFromState,
    deletePaginated,
} from "../../helpers/reduxUtils";

const initialState = {
    searchResults: null,
    isLoading: false,
    companies: null,
    success: false,
    company: null,
    systemlogs: [],
    proxuser: [],
    proxlogs: [],
    cps: [],
    cpProxusers: [],
    searchCps: [],
    apiKey: null,
    currentTrf: null,
    funds: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PROXLOGS_LOADING:
        case SYSTEMLOGS_LOADING:
        case PROXUSER_LOADING:
        case COMPANY_LOADING:
        case APIKEY_LOADING:
        case CP_LOADING:
            return {
                ...state,
                success: false,
                isLoading: true,
            };
        case CP_FUND_COMPLETED:
            return {
                ...state,
                isLoading: false,
                currentTrf: null,
                funds: created(state.funds, action.payload),
            };
        case CP_FUND_INITATE:
            return {
                ...state,
                isLoading: false,
                currentTrf: action.payload,
            };
        case CP_FUND_HISTORY:
            return {
                ...state,
                isLoading: false,
                funds: action.payload,
            };
        case CP_PROXUSER_DELETED:
            return {
                ...state,
                isLoading: false,
                cpProxusers: deleteFromState(state.cpProxusers, action.payload),
            };
        case CP_PROXUSER_EDITED:
            return {
                ...state,
                isLoading: false,
                cpProxusers: editedUpdate(state.cpProxusers, action.payload),
            };
        case CP_PROXUSER_CREATED:
            return {
                ...state,
                isLoading: false,
                cpProxusers: created(state.cpProxusers, action.payload),
            };
        case CP_PROXUSER_LOADED:
            return {
                ...state,
                isLoading: false,
                cpProxusers: action.payload,
            };
        case CP_SEARCH:
            return {
                ...state,
                isLoading: false,
                searchCps: action.payload,
            };
        case CP_LOADED:
            return {
                ...state,
                isLoading: false,
                cps: action.payload,
            };
        case PROXLOGS_LOADED:
            return {
                ...state,
                isLoading: false,
                proxlogs: action.payload,
            };
        case CP_EDITED:
            return {
                ...state,
                isLoading: false,
                cps: editedUpdate(state.cps, action.payload),
            };
        case PROXUSER_CREATED:
            return {
                ...state,
                isLoading: false,
                proxuser: created(state.proxuser, action.payload),
            };
        case PROXUSER_EDITED:
            return {
                ...state,
                isLoading: false,
                proxuser: editedUpdate(state.proxuser, action.payload),
            };
        case PROXUSER_DELETED:
            return {
                ...state,
                isLoading: false,
                proxuser: deleteFromState(state.proxuser, action.payload),
            };
        case PROXUSER_LOADED:
            return {
                ...state,
                isLoading: false,
                proxuser: action.payload,
            };
        case APIKEY_LOADED:
        case APIKEY_GENERATED:
            return {
                ...state,
                isLoading: false,
                apiKey: action.payload,
            };
        case COMPANY_CREATED:
            return {
                ...state,
                company: null,
                success: true,
                isLoading: false,
                companies: createPaginated(state.companies, action.payload),
            };
        case COMPANY_EDITED:
            return {
                ...state,
                success: true,
                company: null,
                isLoading: false,
                companies: editPaginated(state.companies, action.payload),
            };
        case COMPANY_DELETED:
            return {
                ...state,
                isLoading: false,
                companies: deletePaginated(state.companies, action.payload),
            };
        case COMPANY_LOADED:
            return {
                ...state,
                success: false,
                isLoading: false,
                companies: action.payload,
            };
        case COMPANY_DETAILS:
            return {
                ...state,
                success: false,
                isLoading: false,
                company: action.payload,
            };
        case COMPANY_SEARCH:
            return {
                ...state,
                isLoading: false,
                searchResults: action.payload,
            };
        case SYSTEMLOGS_LOADED:
            return {
                ...state,
                isLoading: false,
                systemlogs: action.payload,
            };
        case SYSTEMLOGS_FAILED:
        case PROXLOGS_FAILED:
        case PROXUSER_FAILED:
        case COMPANY_FAILED:
        case APIKEY_FAILED:
        case CP_FAILED:
            return {
                ...state,
                success: false,
                isLoading: false,
                systemlogs: [],
            };
        case LOGOUT:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
